// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lookup-split {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.lookup-left {
  width: 260px;
  flex-shrink: 0;
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.lookup-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.lookup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px 0 16px;
  min-height: 38px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
  background: var(--bg-secondary);
}

.lookup-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: var(--text-secondary);
}

.lookup-list {
  flex: 1;
  overflow-y: auto;
}

.lookup-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  border-left: 2px solid transparent;
  gap: 8px;
  transition: background 0.1s;
}
.lookup-item:hover { background: var(--bg-hover); }
.lookup-item.selected { background: var(--bg-active); border-left-color: var(--accent-light); }

.lookup-item-name { flex: 1; font-size: 13px; }
.lookup-item-sub { font-size: 11px; color: var(--text-muted); }

.lookup-item-actions {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  display: none;
  gap: 2px;
}
.lookup-item:hover .lookup-item-actions { display: flex; }

.lookup-item-new { cursor: pointer; }
.lookup-item-new:hover { background: var(--bg-hover); }
.lookup-item-new-label { font-size: 12px; color: var(--text-muted); }
.lookup-item-new:hover .lookup-item-new-label { color: var(--text-secondary); }

.lookup-empty {
  color: var(--text-muted);
  font-size: 12px;
  padding: 16px;
}

.inline-edit {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
}
.inline-edit input { flex: 1; }

.breaker-new-row {
  display: flex;
  gap: 8px;
  padding: 8px 16px;
  background: var(--bg-tertiary);
  border-bottom: 1px solid var(--border);
  flex-wrap: wrap;
}
.breaker-new-row input { flex: 1; min-width: 80px; }

.breaker-table { table-layout: fixed; }

.board-form {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  width: 100%;
}
.board-form-name    { flex: 1; min-width: 80px; }
.board-form-tag     { width: 60px; }
.board-form-desc    { flex: 2; min-width: 100px; }
.board-form-voltage { width: 80px; }
.board-form-room    { width: 140px; }
.board-form-sections { width: 100%; }
.breaker-table .brk-role { margin-left: 8px; font-size: 11px; font-style: italic; color: var(--text-muted); }
.board-form-actions { display: flex; gap: 2px; flex-shrink: 0; }
.lookup-item-main { display: flex; align-items: center; gap: 6px; flex: 1; overflow: hidden; }
.lookup-item-desc { font-size: 11px; color: var(--text-muted); margin-top: 1px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

/* ── Mobile ── */
@media (max-width: 768px), (hover: none) and (max-width: 1024px) {
  /* Stack panels vertically */
  .lookup-split { flex-direction: column; }

  .lookup-left {
    width: 100%;
    flex-shrink: 0;
    border-right: none;
    border-bottom: 1px solid var(--border);
    max-height: 40vh;
  }

  .lookup-right { flex: 1; min-height: 0; }

  /* Larger touch targets for list items */
  .lookup-item { padding: 10px 12px; min-height: 48px; }
  .lookup-item-name { font-size: 14px; }

  /* Always show edit/delete actions on touch devices */
  .lookup-item-actions {
    display: flex;
    position: static;
    transform: none;
    flex-shrink: 0;
    margin-left: auto;
  }
  .lookup-item-actions .btn-icon {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Board edit form: stack fields vertically */
  .board-form { flex-direction: column; gap: 6px; }
  .board-form-name,
  .board-form-tag,
  .board-form-desc,
  .board-form-voltage,
  .board-form-room,
  .board-form-sections { width: 100%; flex: none; min-width: 0; }
  .board-form-actions { justify-content: flex-end; }

  /* Breaker table rows bigger */
  .data-table.breaker-table td,
  .data-table.breaker-table th { padding: 8px 10px; }
  .data-table.breaker-table input { font-size: 16px !important; min-height: 36px; }

  /* New breaker row stacks on very small screens */
  .breaker-new-row { padding: 8px 12px; }
  .breaker-new-row input { font-size: 16px !important; min-height: 36px; }
}

/* Import from project */
.import-btn-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.import-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 4px;
  z-index: 300;
  min-width: 200px;
  max-height: 260px;
  overflow-y: auto;
  box-shadow: 0 6px 20px rgba(0,0,0,0.45);
}
.import-dropdown-title {
  font-size: 10px;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 8px 12px 6px;
  border-bottom: 1px solid var(--border);
}
.import-dropdown-item {
  display: block;
  width: 100%;
  padding: 7px 12px;
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 12px;
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.import-dropdown-item:hover { background: var(--bg-hover); color: var(--text-primary); }
.import-dropdown-muted {
  padding: 8px 12px;
  font-size: 11px;
  color: var(--text-muted);
}
.import-result {
  font-size: 11px;
  color: #4ec994;
  margin-left: 8px;
  white-space: nowrap;
}
.import-result.import-result-error { color: #f48771; }
`, "",{"version":3,"sources":["webpack://./src/components/lookups/Lookups.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,sCAAsC;EACtC,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,QAAQ;EACR,2BAA2B;AAC7B;AACA,qBAAqB,2BAA2B,EAAE;AAClD,wBAAwB,4BAA4B,EAAE,sCAAsC,EAAE;;AAE9F,oBAAoB,OAAO,EAAE,eAAe,EAAE;AAC9C,mBAAmB,eAAe,EAAE,wBAAwB,EAAE;;AAE9D;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,QAAQ;AACV;AACA,0CAA0C,aAAa,EAAE;;AAEzD,mBAAmB,eAAe,EAAE;AACpC,yBAAyB,2BAA2B,EAAE;AACtD,yBAAyB,eAAe,EAAE,wBAAwB,EAAE;AACpE,gDAAgD,4BAA4B,EAAE;;AAE9E;EACE,wBAAwB;EACxB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;AACT;AACA,qBAAqB,OAAO,EAAE;;AAE9B;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,8BAA8B;EAC9B,sCAAsC;EACtC,eAAe;AACjB;AACA,yBAAyB,OAAO,EAAE,eAAe,EAAE;;AAEnD,iBAAiB,mBAAmB,EAAE;;AAEtC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb;AACA,sBAAsB,OAAO,EAAE,eAAe,EAAE;AAChD,sBAAsB,WAAW,EAAE;AACnC,sBAAsB,OAAO,EAAE,gBAAgB,EAAE;AACjD,sBAAsB,WAAW,EAAE;AACnC,sBAAsB,YAAY,EAAE;AACpC,uBAAuB,WAAW,EAAE;AACpC,2BAA2B,gBAAgB,EAAE,eAAe,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AAC5G,sBAAsB,aAAa,EAAE,QAAQ,EAAE,cAAc,EAAE;AAC/D,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,OAAO,EAAE,gBAAgB,EAAE;AAC7F,oBAAoB,eAAe,EAAE,wBAAwB,EAAE,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;;AAEhJ,iBAAiB;AACjB;EACE,4BAA4B;EAC5B,gBAAgB,sBAAsB,EAAE;;EAExC;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,sCAAsC;IACtC,gBAAgB;EAClB;;EAEA,gBAAgB,OAAO,EAAE,aAAa,EAAE;;EAExC,wCAAwC;EACxC,eAAe,kBAAkB,EAAE,gBAAgB,EAAE;EACrD,oBAAoB,eAAe,EAAE;;EAErC,qDAAqD;EACrD;IACE,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,6CAA6C;EAC7C,cAAc,sBAAsB,EAAE,QAAQ,EAAE;EAChD;;;;;yBAKuB,WAAW,EAAE,UAAU,EAAE,YAAY,EAAE;EAC9D,sBAAsB,yBAAyB,EAAE;;EAEjD,8BAA8B;EAC9B;iCAC+B,iBAAiB,EAAE;EAClD,kCAAkC,0BAA0B,EAAE,gBAAgB,EAAE;;EAEhF,iDAAiD;EACjD,mBAAmB,iBAAiB,EAAE;EACtC,yBAAyB,0BAA0B,EAAE,gBAAgB,EAAE;AACzE;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,sCAAsC;AACxC;AACA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,8BAA8B,2BAA2B,EAAE,0BAA0B,EAAE;AACvF;EACE,iBAAiB;EACjB,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA,qCAAqC,cAAc,EAAE","sourcesContent":[".lookup-split {\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n}\n\n.lookup-left {\n  width: 260px;\n  flex-shrink: 0;\n  border-right: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.lookup-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.lookup-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 12px 0 16px;\n  min-height: 38px;\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n  background: var(--bg-secondary);\n}\n\n.lookup-title {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  color: var(--text-secondary);\n}\n\n.lookup-list {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.lookup-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-left: 2px solid transparent;\n  gap: 8px;\n  transition: background 0.1s;\n}\n.lookup-item:hover { background: var(--bg-hover); }\n.lookup-item.selected { background: var(--bg-active); border-left-color: var(--accent-light); }\n\n.lookup-item-name { flex: 1; font-size: 13px; }\n.lookup-item-sub { font-size: 11px; color: var(--text-muted); }\n\n.lookup-item-actions {\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: none;\n  gap: 2px;\n}\n.lookup-item:hover .lookup-item-actions { display: flex; }\n\n.lookup-item-new { cursor: pointer; }\n.lookup-item-new:hover { background: var(--bg-hover); }\n.lookup-item-new-label { font-size: 12px; color: var(--text-muted); }\n.lookup-item-new:hover .lookup-item-new-label { color: var(--text-secondary); }\n\n.lookup-empty {\n  color: var(--text-muted);\n  font-size: 12px;\n  padding: 16px;\n}\n\n.inline-edit {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex: 1;\n}\n.inline-edit input { flex: 1; }\n\n.breaker-new-row {\n  display: flex;\n  gap: 8px;\n  padding: 8px 16px;\n  background: var(--bg-tertiary);\n  border-bottom: 1px solid var(--border);\n  flex-wrap: wrap;\n}\n.breaker-new-row input { flex: 1; min-width: 80px; }\n\n.breaker-table { table-layout: fixed; }\n\n.board-form {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  align-items: center;\n  width: 100%;\n}\n.board-form-name    { flex: 1; min-width: 80px; }\n.board-form-tag     { width: 60px; }\n.board-form-desc    { flex: 2; min-width: 100px; }\n.board-form-voltage { width: 80px; }\n.board-form-room    { width: 140px; }\n.board-form-sections { width: 100%; }\n.breaker-table .brk-role { margin-left: 8px; font-size: 11px; font-style: italic; color: var(--text-muted); }\n.board-form-actions { display: flex; gap: 2px; flex-shrink: 0; }\n.lookup-item-main { display: flex; align-items: center; gap: 6px; flex: 1; overflow: hidden; }\n.lookup-item-desc { font-size: 11px; color: var(--text-muted); margin-top: 1px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n\n/* ── Mobile ── */\n@media (max-width: 768px), (hover: none) and (max-width: 1024px) {\n  /* Stack panels vertically */\n  .lookup-split { flex-direction: column; }\n\n  .lookup-left {\n    width: 100%;\n    flex-shrink: 0;\n    border-right: none;\n    border-bottom: 1px solid var(--border);\n    max-height: 40vh;\n  }\n\n  .lookup-right { flex: 1; min-height: 0; }\n\n  /* Larger touch targets for list items */\n  .lookup-item { padding: 10px 12px; min-height: 48px; }\n  .lookup-item-name { font-size: 14px; }\n\n  /* Always show edit/delete actions on touch devices */\n  .lookup-item-actions {\n    display: flex;\n    position: static;\n    transform: none;\n    flex-shrink: 0;\n    margin-left: auto;\n  }\n  .lookup-item-actions .btn-icon {\n    width: 38px;\n    height: 38px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* Board edit form: stack fields vertically */\n  .board-form { flex-direction: column; gap: 6px; }\n  .board-form-name,\n  .board-form-tag,\n  .board-form-desc,\n  .board-form-voltage,\n  .board-form-room,\n  .board-form-sections { width: 100%; flex: none; min-width: 0; }\n  .board-form-actions { justify-content: flex-end; }\n\n  /* Breaker table rows bigger */\n  .data-table.breaker-table td,\n  .data-table.breaker-table th { padding: 8px 10px; }\n  .data-table.breaker-table input { font-size: 16px !important; min-height: 36px; }\n\n  /* New breaker row stacks on very small screens */\n  .breaker-new-row { padding: 8px 12px; }\n  .breaker-new-row input { font-size: 16px !important; min-height: 36px; }\n}\n\n/* Import from project */\n.import-btn-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.import-dropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  z-index: 300;\n  min-width: 200px;\n  max-height: 260px;\n  overflow-y: auto;\n  box-shadow: 0 6px 20px rgba(0,0,0,0.45);\n}\n.import-dropdown-title {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 8px 12px 6px;\n  border-bottom: 1px solid var(--border);\n}\n.import-dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 7px 12px;\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 12px;\n  text-align: left;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.import-dropdown-item:hover { background: var(--bg-hover); color: var(--text-primary); }\n.import-dropdown-muted {\n  padding: 8px 12px;\n  font-size: 11px;\n  color: var(--text-muted);\n}\n.import-result {\n  font-size: 11px;\n  color: #4ec994;\n  margin-left: 8px;\n  white-space: nowrap;\n}\n.import-result.import-result-error { color: #f48771; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
